var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "base-scroll", attrs: { id: "app" } },
    [
      _vm.isLoginPage
        ? [_c("Login")]
        : [
            _c("Menu"),
            _c(
              "main",
              { ref: "mainContainer", staticClass: "mainEl" },
              [_c("router-view", { staticClass: "main-container" })],
              1
            ),
            _c("img", {
              staticClass: "asideLogo",
              attrs: { src: require("@/assets/asideLogo.png"), alt: "" },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }